module.exports = __webpack_public_path__ + "static/media/insta-top2.2b6d86f7.jpg";